import { Link } from "react-router-dom";
import { SustainabilityScoreBadge } from "./SustainabilityScoreBadge";
import { AlertTriangle, AlertOctagon } from "lucide-react";

export function BrandCard({ brand }) {
  const warningsTotal = brand.warnings_total || 0;
  return (
    <Link
      to={`/brands/${brand.slug}`}
      className="text-left group bg-white border border-line rounded-2xl overflow-hidden hover:shadow-lg transition-shadow duration-300 w-full block"
      data-testid={`brand-card-${brand.slug}`}
    >
      <div className="relative aspect-square bg-white overflow-hidden">
        {brand.logo_url && (
          <img src={brand.logo_url} alt={brand.name} loading="lazy" className="w-full h-full object-contain p-6 group-hover:scale-[1.03] transition-transform duration-500" />
        )}
        <div className="absolute top-3 left-3 flex flex-col gap-2 items-start">
          {brand.is_featured && (
            <span
              className="text-[10px] font-semibold uppercase tracking-wider rounded-full px-2 py-1 bg-leaf/15 text-leaf"
              data-testid={`brand-card-featured-pill-${brand.slug}`}
            >
              Featured
            </span>
          )}
          {warningsTotal > 0 && (
            <div
              className="inline-flex items-center gap-1.5 bg-clay text-ivory text-xs font-medium uppercase tracking-wider px-2.5 py-1 rounded-full shadow-md"
              data-testid={`brand-card-warning-badge-${brand.slug}`}
            >
              <AlertOctagon className="w-3.5 h-3.5" />
              <span>{warningsTotal} warning{warningsTotal === 1 ? "" : "s"}</span>
            </div>
          )}
        </div>
      </div>
      <div className="p-3.5">
        <div className="flex items-start justify-between gap-2 mb-1.5">
          <h3 className="font-serif text-lg leading-tight">{brand.name}</h3>
          <SustainabilityScoreBadge score={brand.sustainability_score} size="sm" />
        </div>
        {brand.description_short && (
          <p className="text-xs text-muted_text line-clamp-2 mb-2">{brand.description_short}</p>
        )}
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-muted_text">
          <span>{brand.total_reviewed_items || 0} reviewed</span>
          <span className="text-leaf">{brand.total_approved_items || 0} approved</span>
          {brand.country && <span>{brand.country}</span>}
          {brand.primary_material_focus && <span>· {brand.primary_material_focus}</span>}
          {brand.false_advertising_flags_count > 0 && (
            <span className="inline-flex items-center gap-1 text-clay"><AlertTriangle className="w-3 h-3" /> {brand.false_advertising_flags_count} flag(s)</span>
          )}
        </div>
      </div>
    </Link>
  );
}
